const addressTypes = {
  Physical: 1,
  Postal: 2,
};

export default addressTypes;
